import styled from "@emotion/styled";
import { screen } from "../../constants/dimensions";

export const StyledShell = styled.div`
  overflow: hidden;
  width: ${screen.width}px;
  height: ${screen.height}px;
  position: relative;
`;
